import { Image } from "../../../../components/common/image";

interface ProductRequestImageProps {
  image: string;
  productName: string;
}

// Fixed-height surface that the image fits inside via object-contain. Without
// the explicit container height the underlying <Image> would stretch to the
// img's natural aspect ratio (a tall portrait at 448px wide becomes ~700px
// tall) and overflow the SectionCard. Letting the container drive the height
// and clamping the img with size + object-contain keeps the hero a stable
// shape regardless of source image dimensions.
export function ProductRequestImage({
  image,
  productName,
}: ProductRequestImageProps) {
  return (
    <div className="flex w-full">
      <div className="flex h-80 w-full max-w-md items-center justify-center overflow-hidden rounded-lg border border-borderDefault bg-bgLight">
        <Image
          image={image}
          alt={productName || "Product"}
          size="max-h-full max-w-full"
          objectFit="contain"
        />
      </div>
    </div>
  );
}
